import { Injectable, inject } from '@angular/core';
import { Observable, filter, switchMap } from 'rxjs';
import { FeatureFlagFacade } from '@rx-applications/shared/clientsite/feature-flags';
import { ConfigFacade } from '../state/config.facade';

@Injectable({
  providedIn: 'root',
})
export class RailLink {
  readonly #featureFlagFacade = inject(FeatureFlagFacade);
  readonly #configFacade = inject(ConfigFacade);

  trainlineHyperLink$: Observable<string> = this.#featureFlagFacade.useReportV2TrainlineEnabled$.pipe(
    filter((enabled) => enabled),
    switchMap(() => this.#configFacade.trainlineHyperlink$),
  );
}
